import { type Expect } from '@type-challenges/utils';
import { type FunctionComponent } from 'react';
import { type O } from 'ts-toolbelt';
import { type SimplifyDeep } from 'type-fest';
import { type StrictSubsetOfRootState } from '../../core/root.state';
import { DesktopMenu, type DesktopMenuState } from './DesktopMenu/DesktopMenu';
import styles from './Menu.module.css';
import { MobileMenu, type MobileMenuState } from './MobileMenu/MobileMenu';

export type MenuProps = {
  failSafe?: boolean;
};

export type MenuState = SimplifyDeep<
  O.Assign<object, [DesktopMenuState, MobileMenuState], 'deep'>
>;

type CheckState = Expect<StrictSubsetOfRootState<MenuState>>;

export const Menu: FunctionComponent<MenuProps> = ({ failSafe = false }) => {
  return (
    <div className={styles.root}>
      <DesktopMenu className={styles.desktop} failSafe={failSafe} />
      <MobileMenu className={styles.mobile} failSafe={failSafe} />
    </div>
  );
};
